import {environment as env} from '../../environments/environment';
export function usersnapInit() {
  
  window['onUsersnapLoad'] = (api) => {
    
    api.init({
      custom: {
        applicationLanguage : localStorage.getItem('lang') || window.navigator?.language?.slice(0, 2) || 'en',
      },
      button: {isHidden: true},
      locale: localStorage.getItem('lang') || window.navigator?.language?.slice(0, 2) || 'en'
    });

    // hide button and expose API to trigger manually
    window['onUsersnapLoad'] = undefined;
    window['Usersnap'] = api;

    window['Usersnap'].on('open', (event) => {
      console.log("event", event);
      
      event.api.setValue('locale', localStorage.getItem('lang') || window.navigator?.language?.slice(0, 2) || 'en')
    })
  };

  // const s = document.createElement('script');
  // s.type = 'text/javascript';
  // s.async = true;
  // s.src = 'https://widget.usersnap.com/global/load/604178c6-86a9-4f35-a8e4-acb23eab7c07?onload=onUsersnapLoad';
  // const x = document.getElementsByTagName('script')[0];
  // x.parentNode.insertBefore(s, x);

  var script = document.createElement('script');
  script.defer = true;
  script.src = `https://widget.usersnap.com/load/${env.usersnap}?onload=onUsersnapLoad`;
  document.getElementsByTagName('head')[0].appendChild(script);
}env

